/**
 * Adjuntos de solicutud de pago
 *
 */
import React from 'react'
import { Table, Button, Modal, Row, Col } from 'antd'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'

export default class Pagos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    const LabelledValue = ({ label, value }) => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ marginRight: 7 }}>{label}</label>
        <strong>{value}</strong>
      </div>
    )

    const RowValue = ({ label, value }) => (
      <div style={styles.row}>
        <LabelledValue label={label} value={value} />
      </div>
    )

    // this.requestNewFile(record, record.sFiltro)
    this.columns = Cell.buildList([
      { width: '3%', title: 'INFORMACIÓN GRAL', dataIndex: 'sFolio', render: (_, record) => (
        <div>
          <RowValue label='FOLIO' value={record.sFolio} />
          <RowValue label='FECHA' value={record.dFecha} />
          <RowValue label='STATUS' value={record.sStatus} />
        </div>
      )},
      { width: '7%', title: 'HORARIOS', dataIndex: 'dHoraInicio', render: (_, record) => (
        <div>
          <Row>
            <Col span={11}>
              <LabelledValue label='HR INICIO' value={record.dHoraInicio} />
              <LabelledValue label='HR TERMINO' value={record.dHoraTermino} />
              <LabelledValue label={'HR\'S EFECTIVAS'} value={record.dHorasEfectivas} />
            </Col>
            <Col span={2} />
            <Col span={11}>
              <LabelledValue label='PARO INICIO' value={record.dParoInicio || 'N/A'} />
              <LabelledValue label='PARO TERMINO' value={record.dParoTermino || 'N/A'} />
              <LabelledValue label={'HR\'S PARO'} value={record.dHorasParo} />
            </Col>
          </Row>
        </div>
      )},
      { width: '7%', title: 'ÁREA & ACTIVIDADES', dataIndex: 'sArea', render: (_, record) => (
        <div>
          <RowValue label='RESPONSABLE' value={record.responsable.sNombre} />
          <RowValue label='ÁREA' value={record.sArea} />
          <RowValue label='ACTIVIDADES' value={record.sActividades} />
        </div>
      )},
      { width: '7%', title: 'USUARIOS', dataIndex: 'sArea', render: (_, record) => (
        <div>
          <RowValue label='CABO' value={record.cabo ? record.cabo.sNombre : 'S/N'} />
          <RowValue label='ALMACÉN' value={record.almacen ? record.almacen.sNombre : 'S/N'} />
          <RowValue label='AUTORIZA' value={record.autoriza ? record.autoriza.sNombre : 'S/N'} />
        </div>
      )},
    ])

    this.state = {
      templates: [],
      data: [],
      loading: false,
      solicitudId: 0,
    }
  }

  /**
   * Load
   *
   * @param {Number} solicitudId
   */
  load = ({ from, to, specialId }) => {
    this.setState({
      visible: true,
      loading: true,
      data: [],
      from,
      to,
      specialId,
    })

    const query = {
      model: 'MaqBitacora',
      attributes: [
        'iId',
        'sFolio',
        'dFecha',
        'sStatus',
        'dHoraInicio',
        'dHoraTermino',
        'dHorasEfectivas',
        'dParoInicio',
        'dParoTermino',
        'dHorasParo',
        'sArea',
        'sActividades',
      ],
      include: [
        { as: 'responsable', attributes: ['sNombre'] },
        { as: 'cabo', required: false, attributes: ['sNombre'] },
        { as: 'almacen', required: false, attributes: ['sNombre'] },
        { as: 'autoriza', required: false, attributes: ['sNombre'] },
      ],
      where: {
        iIdEspecial: specialId,
        $and: [
          { dFecha: { $gte: from }},
          { dFecha: { $lte: to }},
        ],
        iActivo: true,
      }
    }

    Api.query(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data,
        })
      )
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='BITACORA DE ACTIVIDADES'
        visible={this.state.visible}
        onOk={() => this.setState({ visible: false })}
        style={{ minWidth: '95%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        }
      />
    )
  }
}

const styles = {
  row: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
  },
}
